import _ from "lodash";
import { formattedAmount } from "../../../utils/index";

export function getIndustryData ( data, industry ){
    return _.sortBy(_.map(_.entries(data), (([ month, partys ]) => {
        return {
            month,
            data: _.filter(_.entries(partys), ([ party, entity ]) => {
                return entity.industry === industry;
            })
        }
    })), 'month');
}

export function parseIndustryData ( data, industry ){
    let partys = new Map();
    let _data = getIndustryData( data, industry );
    _data.forEach( item => {
        item?.data.forEach( ([ party, entity ]) => {
            let _expense = entity?.expense || 0;
            let _other = entity?.other || 0;
            partys.set(party, (partys.get(party) || 0) + _expense + _other );
        });
    });
    //计算机构总数
    let totalPartys = partys.size;
    //计算周期履约金额
    let totalExpense = _.round(_.sum(_.map(_.entries(partys), ([, total]) => total)),2);
    //计算月均履约金额
    let monthCount = _data.length - 1;  // 计算有效月份数
    let avgExpense = monthCount > 0 ? _.round(totalExpense / monthCount, 2) : 0;
    return {
        totalPartys,
        totalExpense,
        avgExpense
    };
}

export function data2Series ( data, industry = '' ){
    const months = _.map(data, 'month');
    //获取party在每个月的expense放在一个数组中, 并根据party的expense大小排序
    const partys = _.uniq(_.flatten(_.map(_.map(data, 'data'), item => {
        return _.map(item, item => {
            return item[0];
        });
    })));
     //根据partys的expense大小调整顺序
    partys.sort((a, b) => {
        const aExpense = _.sum(_.map(data, item => {
            const entity = _.find(item.data, ([ p ]) => p === a);
            return entity ? entity[1]?.expense : 0;
        }));
        const bExpense = _.sum(_.map(data, item => {
            const entity = _.find(item.data, ([ p ]) => p === b);
            return entity ? entity[1]?.expense : 0;
        }));
        return bExpense - aExpense; // 降序排列
    });
    let series = _.map(partys, party => {
        return {
            name: party,
            type: 'bar',
            emphasis: {
                focus: 'series'
            },
            barWidth: '10%',
            stack: 'stack',
            data: _.map(data, item => {
                const entity = _.find(item.data, ([ p ]) => p === party);
                let isAddOthers = industry === 'Financial';
                if( isAddOthers ){
                    //如果是金融行业，其他的支出也要统计
                    return {
                        "value": entity ? (entity[1]?.expense + entity[1]?.other) : 0,
                        "TARGET": party
                    }
                }
                return {
                    "value": entity ? entity[1]?.expense : 0,
                    "TARGET": party
                }
            })
        }
    });
    series.push({
        name: '月总支出',
        type: 'bar',
        emphasis: {
            focus: 'series'
        },
        stack: 'total',
        data: _.map(data, item => {
            //如果是金融行业，其他的支出也要统计
            if( industry === 'Financial' ){
                return {
                    "value": _.sum(_.map(item.data, ([ p, entity ]) => entity.expense + entity.other)),
                    "TARGET": item.month + '月总支出'
                }
            }
            return {
                "value": _.sum(_.map(item.data, ([ p, entity ]) => entity.expense)),
                "TARGET": item.month + '月总支出'
            }
        })
    });

    return {
        title: {},
        tooltip: {
            trigger: 'axis',
            formatter: function(params){
                if( params[0]?.seriesName === '月总支出' ){
                    //统计这个月，统计data中所有平台的对应支出
                    let _data = data.map( item => {
                        if( item.month === params[0].name ){
                            return item.data.map( _party => {
                                if( industry === 'Financial' ){
                                    //如果是金融行业，其他的支出也要统计
                                    return `<div class="series-item"><b>${_party[0]}</b>:${formattedAmount(_party[1].expense + _party[1].other)}</div>`;
                                }
                                //其他行业只统计expense
                                return `<div class="series-item"><b>${_party[1].party}</b>:${formattedAmount(_party[1].expense)}</div>`;
                            });
                        }
                    });
                    //按expense的顺序排列
                    _data = _.filter(_.flatten(_data, item => item));
                    _data.unshift(`<div class="series-item"><b>月总支出</b>:${formattedAmount(params[0].data.value)}</div>`);
                    return _data.join('')
                }
                else {
                    let result = _.filter(params, item => {
                        return item?.data?.value > 0;
                    });
                    return _.map(result, item => {
                        return `<div><i style="display:inline-block; background-color:${item?.color};border-radius:50%;width:12px;height:12px;"></i>
                            <b>${item?.seriesName}</b>：${formattedAmount(item?.data?.value)}</div>`;
                    }).join('');
                }
            },
            axisPointer: {
                type: 'cross',
                crossStyle: {
                    color: '#ccc'
                }
            }
        },
        "legend": {
            type: 'scroll',
            orient: 'horizontal',
            selectedMode: 'single',
            formatter: function(name) {
                return name.length > 10 ? name.substring(0, 10) + '...' : name;
            },
            legend: function (params) {
                console.log(params);
            }
        },
        "xAxis": { 
            type: 'category',
            axisTick: {
                show: false
            },
            axisLine: {
                show: false
            },
            data: months
        },
        "yAxis": {
            axisLine: {
                show: false
            },
            axisTick: {
                show: false
            }
        },
        "series": series
    };
}